<template>
  <v-container fluid class="pa-0">
    <v-app-bar app color="black" height="106px">
      <v-layout justify-center>
        <v-col cols="12" xl="10" lg="11" class="app-bar">
          <v-layout row justify-space-between>
            <v-layout row class="shrink" align-center hidden-sm-and-down>
              <v-btn dark text v-scroll-to="'#header'" class="btn">Home</v-btn>
              <v-btn dark text v-scroll-to="'#content'" class="btn"
                >Portfolio</v-btn
              >
              <v-btn dark text v-scroll-to="'#services'" class="btn"
                >Services</v-btn
              >
              <v-btn dark text v-scroll-to="'#about'" class="btn"
                >Contact</v-btn
              >
            </v-layout>

            <v-layout row align-center justify-center>
              <v-img
                class="shrink"
                height="46"
                width="46"
                contain
                :src="require('../assets/logo.png')"
              />
              <div class="title">profuse</div>
            </v-layout>

            <v-layout row class="shrink" align-center hidden-sm-and-down>
              <v-btn
                href="https://www.facebook.com/profusemd/"
                target="_blank"
                dark
                icon
                text
              >
                <v-img height="13" contain :src="require('../assets/fb.png')" />
              </v-btn>
              <v-btn
                href="https://www.linkedin.com/company/profusesrl/"
                target="_blank"
                dark
                icon
                text
              >
                <v-img
                  height="13"
                  contain
                  :src="require('../assets/linkedin.png')"
                />
              </v-btn>
              <v-btn dark icon text>
                <v-img
                  height="13"
                  contain
                  :src="require('../assets/twitter.png')"
                />
              </v-btn>
              <v-btn
                href="https://www.instagram.com/profuse.md/"
                target="_blank"
                dark
                icon
                text
              >
                <v-img
                  height="13"
                  contain
                  :src="require('../assets/inst.png')"
                />
              </v-btn>
              <v-btn
                @click="openEmail"
                dark
                height="60"
                width="170"
                outlined
                tile
                class="ml-6"
              >
                <div style="color: #3967ff">Let's Talk</div>
              </v-btn>
            </v-layout>
          </v-layout>
        </v-col>
      </v-layout>
    </v-app-bar>

    <v-main class="pa-0">
      <v-container fluid class="header" id="header">
        <video-player
          class="video-player-box"
          ref="videoPlayer"
          :options="playerOptions"
        />
      </v-container>

      <v-container fluid class="content" id="content">
        <v-layout justify-center>
          <v-col cols="12" xl="8" lg="8" md="10" sm="12" class="pa-0">
            <v-layout justify-center align-center>
              <div class="title-line" />
              <div class="portfolio">PORTFOLIO</div>
              <div class="title-line" />
            </v-layout>

            <v-carousel :show-arrows="true" cycle hide-delimiters height="100%">
              <v-carousel-item v-for="(app, i) in portfolio" :key="i">
                <v-sheet color="transparent" height="100%">
                  <v-layout column>
                    <div class="protfolio-title">{{ app.title }}</div>
                    <div class="protfolio-description">
                      {{ app.description }}
                    </div>
                    <v-layout
                      row
                      justify-center
                      class="carousel-buttons"
                      align-center
                    >
                      <v-col cols="12" md="3" sm="12">
                        <v-layout justify-center>
                          <v-img
                            @click="openAppStore(app.appStoreUrl)"
                            height="63px"
                            width="170px"
                            class="shrink ml-4 mr-4 pointer"
                            contain
                            :src="require('../assets/app_store.png')"
                          />
                        </v-layout>
                      </v-col>

                      <v-col cols="12" md="3" sm="12">
                        <v-layout justify-center>
                          <v-btn
                            @click="navigateTo(app.id)"
                            class="see-more ml-4 mr-4 shrink"
                            height="60px"
                            width="170px"
                            color="#3967ff"
                            outlined
                            >See more</v-btn
                          >
                        </v-layout>
                      </v-col>
                    </v-layout>
                    <v-img
                      height="100%"
                      class="shrink mt-15"
                      contain
                      :src="app.image"
                    />
                    <v-layout row class="ad" justify-center v-if="app.adText">
                      <div class="ml-6 mr-3">{{ app.adText }}</div>
                      <div class="underlined" @click="openAd(app.adLink)">
                        {{ app.adLink }}
                      </div>
                    </v-layout>
                  </v-layout>
                </v-sheet>
              </v-carousel-item>
            </v-carousel>
          </v-col>
        </v-layout>
      </v-container>

      <v-container fluid class="services" id="services">
        <v-layout justify-center>
          <v-col cols="12" xl="10" lg="10" sm="10">
            <v-layout justify-center align-center>
              <div class="white-line" />
              <div class="services-section">SERVICES</div>
              <div class="white-line" />
            </v-layout>

            <v-layout justify-start>
              <v-col cols="12" lg="8" md="10" sm="12" class="pa-0">
                <v-layout column>
                  <div
                    v-resize-text="{ ratio: 0.9, maxFontSize: '80px' }"
                    class="services-title"
                  >
                    Develop high‑end apps that
                    <div
                      v-resize-text="{ ratio: 0.9, maxFontSize: '80px' }"
                      style="color: #3967ff"
                    >
                      guarantees results.
                    </div>
                  </div>
                </v-layout>
              </v-col>
            </v-layout>

            <v-layout justify-end>
              <v-col cols="12" lg="8" md="10" sm="12" class="pa-0">
                <div
                  v-resize-text="{ ratio: 0.9, maxFontSize: '20px' }"
                  class="services-description"
                >
                  Profuse is a Digital Agency based in Europe that creates
                  visually stunning apps that engage and leave a lasting
                  impression with your clients.
                </div>
              </v-col>
            </v-layout>

            <v-img
              class="mt-9"
              width="100%"
              contain
              :src="require('../assets/services_background.png')"
            />

            <v-layout justify-center justify-md-end class="mt-7">
              <v-col cols="10" lg="8" md="10" sm="12">
                <v-layout row justify-center>
                  <v-col cols="12" md="6" sm="10" class="pa-0">
                    <v-layout column>
                      <v-layout row class="shrink">
                        <v-icon color="#fff">mdi-check</v-icon>
                        <div class="services-item ma-0 ml-2">
                          Mobile App Development
                        </div>
                      </v-layout>

                      <v-layout row>
                        <v-icon color="#fff">mdi-check</v-icon>
                        <div class="services-item ma-0 ml-2">
                          Mobile App Design
                        </div>
                      </v-layout>

                      <v-layout row>
                        <v-icon color="#fff">mdi-check</v-icon>
                        <div class="services-item ma-0 ml-2">
                          Product Design
                        </div>
                      </v-layout>

                      <v-layout row>
                        <v-icon color="#fff">mdi-check</v-icon>
                        <div class="services-item ma-0 ml-2">
                          Product Development
                        </div>
                      </v-layout>
                    </v-layout>
                  </v-col>

                  <v-col cols="12" md="6" sm="10" class="pa-0">
                    <v-layout column>
                      <v-layout row>
                        <v-icon color="#fff">mdi-check</v-icon>
                        <div class="services-item ma-0 ml-2">
                          eCommerce Development
                        </div>
                      </v-layout>

                      <v-layout row>
                        <v-icon color="#fff">mdi-check</v-icon>
                        <div class="services-item ma-0 ml-2">
                          Desktop App Development
                        </div>
                      </v-layout>

                      <v-layout row>
                        <v-icon color="#fff">mdi-check</v-icon>
                        <div class="services-item ma-0 ml-2">
                          Web development
                        </div>
                      </v-layout>

                      <v-layout row>
                        <v-icon color="#fff">mdi-check</v-icon>
                        <div class="services-item ma-0 ml-2">
                          User experience (UX)
                        </div>
                      </v-layout>
                    </v-layout>
                  </v-col>
                </v-layout>
              </v-col>
            </v-layout>
          </v-col>
        </v-layout>
      </v-container>

      <v-container fluid class="talk" id="talk">
        <v-col cols="12" xl="10" lg="10" sm="12" class="pa-0 mx-auto">
          <v-layout justify-center align-center>
            <div class="title-line" />
            <div class="talk-section">LET'S TALK</div>
            <div class="title-line" />
          </v-layout>

          <v-layout row justify-center mt-15>
            <v-col lg="4" md="4" class="talk-image">
              <v-img
                class="shrink"
                contain
                :src="require('../assets/shuttle.png')"
              />
            </v-col>

            <v-col lg="8" md="8">
              <div
                v-resize-text="{ ratio: 0.9, maxFontSize: '80px' }"
                class="talk-title-black"
              >
                Let’s Talk About
              </div>
              <div
                v-resize-text="{ ratio: 0.9, maxFontSize: '80px' }"
                class="talk-title-blue"
              >
                Your Product.
              </div>

              <div
                v-resize-text="{ ratio: 0.9, maxFontSize: '30px' }"
                class="talk-description mt-9"
              >
                Whether you’re looking to increase brand engagement, enhance
                productivity, or cultivate the best online presence for your
                company, you’ve come to the right place.
              </div>
              <v-btn
                @click="openEmail"
                class="mt-15"
                width="170px"
                height="60px"
                outlined
                color="#3967ff"
                >Let's Talk</v-btn
              >
            </v-col>
          </v-layout>
        </v-col>
      </v-container>

      <v-container fluid class="about" id="about">
        <v-layout align-center class="about">
          <v-col cols="12" xl="10" lg="10" sm="10" class="mx-auto">
            <v-row>
              <v-col
                class="about-container-col"
                cols="12"
                lg="3"
                md="3"
                sm="12"
              >
                <v-layout
                  column
                  align-center
                  justify-center
                  style="height: 100%"
                >
                  <v-layout class="shrink" align-center>
                    <v-img
                      class="shrink"
                      height="46"
                      width="46"
                      contain
                      :src="require('../assets/logo.png')"
                    />
                    <div class="title">profuse</div>
                  </v-layout>

                  <div class="email">hello@profuse.md</div>
                  <div class="phone">+ 373 0 696 32 750</div>

                  <v-layout class="shrink" align-center hidden-sm-and-down>
                    <v-btn
                      href="https://www.facebook.com/profusemd/"
                      target="_blank"
                      dark
                      icon
                      text
                    >
                      <v-img
                        height="13"
                        contain
                        :src="require('../assets/fb.png')"
                      />
                    </v-btn>
                    <v-btn
                      href="https://www.linkedin.com/company/profusesrl/"
                      target="_blank"
                      dark
                      icon
                      text
                    >
                      <v-img
                        height="13"
                        contain
                        :src="require('../assets/linkedin.png')"
                      />
                    </v-btn>
                    <v-btn dark icon text>
                      <v-img
                        height="13"
                        contain
                        :src="require('../assets/twitter.png')"
                      />
                    </v-btn>
                    <v-btn dark icon text>
                      <v-img
                        href="https://www.instagram.com/profuse.md/"
                        target="_blank"
                        height="13"
                        contain
                        :src="require('../assets/inst.png')"
                      />
                    </v-btn>
                  </v-layout>
                </v-layout>
              </v-col>

              <v-col
                class="about-container-col"
                cols="12"
                lg="3"
                md="3"
                sm="12"
              >
                <v-layout
                  column
                  align-center
                  justify-center
                  style="height: 100%"
                >
                  <v-layout column class="shrink" justify-start>
                    <div
                      class="about-section"
                      dark
                      text
                      v-scroll-to="'#header'"
                    >
                      Home
                    </div>
                    <div
                      class="about-section"
                      dark
                      text
                      v-scroll-to="'#content'"
                    >
                      Portfolio
                    </div>
                    <div
                      class="about-section"
                      dark
                      text
                      v-scroll-to="'#services'"
                    >
                      Services
                    </div>
                    <div
                      class="about-section"
                      dark
                      text
                      v-scroll-to="'#Contact'"
                    >
                      Contact
                    </div>
                  </v-layout>
                </v-layout>
              </v-col>

              <v-col
                class="about-container-col"
                cols="12"
                lg="6"
                md="6"
                sm="12"
              >
                <v-layout column align-center justify-end style="height: 100%">
                  <v-layout column justify-start>
                    <div class="have-question">
                      Have a question? Drop us a line!
                    </div>

                    <div class="email-input">EMAIL</div>
                    <v-text-field
                      v-model="email"
                      class="ma-0 pa-0"
                      dark
                    ></v-text-field>

                    <div class="message-input">MESSAGE</div>
                    <v-textarea v-model="message" dark></v-textarea>

                    <v-btn
                      @click="sendEmail"
                      class
                      dark
                      height="60"
                      width="170"
                      outlined
                      tile
                    >
                      <div style="color: #3967ff">Send</div>
                    </v-btn>
                  </v-layout>
                </v-layout>
              </v-col>
            </v-row>
          </v-col>
        </v-layout>
      </v-container>
    </v-main>
  </v-container>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);
export default {
  data() {
    return {
      email: null,
      message: null,
      playerOptions: {
        loop: true,
        autoplay: true,
        controls: false,
        fluid: true,
        muted: true,
        language: "en",
        sources: [
          {
            type: "video/mp4",
            src:
              "https://1192292578.rsc.cdn77.org/sites/profuse2020/brandest_presentation.mp4",
          },
        ],
        poster:
          "https://1192292578.rsc.cdn77.org/sites/profuse2020/brandest_preview.png",
      },
      portfolio: [
        {
          id: "fitflame",
          title: "FitFlame - Hot Woman Fitness",
          description: "Challenge yourself with a 30-day workout plan!",
          image: require("../assets/fitflame.png"),
          appStoreUrl:
            "https://apps.apple.com/us/app/fitflame-hot-woman-fitness/id1504260406",
        },
        {
          id: "galaxy-birds",
          title: "Galaxy Birds - Space Shooting",
          description: "Infinite Alien Shooter Game!",
          image: require("../assets/galaxy_birds.png"),
          appStoreUrl:
            "https://apps.apple.com/us/app/galaxy-birds-space-shooting/id1414776043",
        },
        {
          id: "smart-blocks",
          title: "Smart Blocks Puzzle",
          description: "Fill the board. It's not easy!",
          image: require("../assets/smart_block.png"),
          adText:
            "Underrated Board Games To Play On iOS. Smart Blocks Puzzle on",
          adLink: "gameskeys.net",
          appStoreUrl:
            "https://apps.apple.com/us/app/smart-blocks-puzzle/id1498638665",
        },
        {
          id: "brain-puzzle",
          title: "Brain Puzzle Challenge",
          description: "Train your brain!",
          image: require("../assets/brain_puzzle.png"),
          appStoreUrl:
            "https://apps.apple.com/us/app/brain-puzzle-challenge/id1506175447",
        },
        {
          id: "call-recorder",
          title: "Call Recorder App",
          description: "Auto Phone Calls Recording",
          image: require("../assets/call_recorder.png"),
          appStoreUrl:
            "https://apps.apple.com/us/app/call-recorder-app/id1476041890",
        },
        {
          id: "signature-stamp",
          title: "Signature Stamp",
          description: "Your real signature on any doc",
          image: require("../assets/signature_stamp.png"),
          appStoreUrl:
            "https://apps.apple.com/us/app/signature-stamp/id1502608223",
        },
        {
          id: "brandest",
          title: "Brandest",
          description: "Fashion brands challenge",
          image: require("../assets/brandest.png"),
          appStoreUrl: "https://apps.apple.com/us/app/brandest/id1488087758",
        },
      ],
    };
  },
  methods: {
    navigateTo(path) {
      if (path == "call-recorder") {
        window.open("https://profuse.md/callrecorder/", "_blank");
      } else if (path == "fitflame") {
        window.open("https://fitflame.app/", "_blank");
      } else {
        this.$router.push(path);
      }
    },
    openAd(link) {
      window.open("https://" + link, "_blank");
    },
    sendEmail() {
      axios
        .post("src/scripts/mail.php", {
          email: this.email,
          message: this.message,
        })
        .then((response) => {
          console.log(response);
          this.email = "";
          this.message = "";
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openAppStore(url) {
      window.open(url, "_blank");
    },
    openEmail() {
      window.open("mailto:hello@profuse.md", "_blank");
    },
  },
};
</script>

<style scoped>
.btn {
  text-transform: none;
}
.pointer {
  cursor: pointer;
}
.title {
  color: white;
  margin-left: 13px;
}
.header {
  padding: 0px;
  background-color: black;
}
.content {
  padding: 0px;
  padding-top: 70px;
}
.services {
  padding: 0px;
  background-color: black;
}
.app-bar {
  background-color: black;
}
.title-line {
  width: 140px;
  height: 0;
  border: solid 1px #000000;
}
.white-line {
  width: 140px;
  height: 0;
  border: solid 1px #ffffff;
}
.portfolio {
  font-family: "GillSans";
  font-size: 16px;
  font-weight: bold;
  line-height: 1.19;
  letter-spacing: 3.2px;
  text-align: center;
  color: #000000;
  margin-left: 40px;
  margin-right: 40px;
}
.protfolio-title {
  font-family: "GillSans";
  font-weight: bold;
  line-height: 1.16;
  text-align: center;
  color: #3967ff;
  margin-top: 50px;
  font-size: 80px;
}
@media (max-width: 600px) {
  .protfolio-title {
    font-size: 50px;
  }
}
.protfolio-description {
  font-family: "GillSans";
  font-size: 30px;
  line-height: 1.67;
  text-align: center;
  color: #000000;
}
.carousel-buttons {
  margin-top: 40px;
}
.see-more {
  border-radius: 10px;
  border: solid 1px #3967ff;
}
.services {
  font-family: "GillSans";
  font-size: 16px;
  font-weight: bold;
  line-height: 1.19;
  letter-spacing: 3.2px;
  text-align: center;
  color: #ffffff;
  padding-top: 70px;
}
.services-section {
  font-family: "GillSans";
  font-size: 16px;
  font-weight: bold;
  line-height: 1.19;
  letter-spacing: 3.2px;
  text-align: center;
  color: #ffffff;
  margin-left: 40px;
  margin-right: 40px;
}
.services-title {
  font-family: "GillSans";
  font-size: 80px;
  font-weight: bold;
  line-height: 1.16;
  text-align: left;
  color: #ffffff;
  margin-top: 50px;
}
.services-title-blue {
  font-family: "GillSans";
  font-size: 80px;
  font-weight: bold;
  line-height: 1.16;
  text-align: left;
  color: #3967ff;
  margin-top: 50px;
  margin: 0px;
}
.services-description {
  font-family: "GillSans";
  font-size: 30px;
  line-height: 1.67;
  text-align: left;
  color: #ffffff;
  margin-top: 40px;
}
.services-item {
  font-family: "WorkSans";
  font-size: 18px;
  line-height: 2.78;
  text-align: left;
  color: #ffffff;
  margin-left: 31px;
}
@media (max-width: 600px) {
  .services-item {
    font-size: 16px;
  }
}
.talk {
  margin-top: 70px;
}
.talk-section {
  font-family: "GillSans";
  font-size: 16px;
  font-weight: bold;
  line-height: 1.7;
  letter-spacing: 3.2px;
  color: #000000;
  margin-left: 40px;
  margin-right: 40px;
  text-align: center;
}
.talk-title-black {
  font-family: "GillSans";
  font-size: 80px;
  font-weight: bold;
  line-height: 1.16;
  text-align: left;
  color: #000000;
}
.talk-title-blue {
  font-family: "GillSans";
  font-size: 80px;
  font-weight: bold;
  line-height: 1.16;
  text-align: left;
  color: #3967ff;
}
.talk-description {
  font-family: "GillSans";
  font-size: 30px;
  line-height: 1.67;
  text-align: left;
  color: #181726;
}
.talk-image {
  align-self: center;
  margin-bottom: -100px;
}
@media (max-width: 960px) {
  .talk-image {
    margin-bottom: 0px;
  }
}
.about {
  background-color: #000000;
  min-height: 700px;
}
.about-container-col {
  margin-top: 20px;
  margin-bottom: 20px;
}
.email {
  font-family: "WorkSans";
  font-size: 16px;
  line-height: 2.38;
  text-align: left;
  color: #ffffff;
  margin-top: 60px;
}
.phone {
  font-family: "WorkSans";
  font-size: 16px;
  line-height: 2.38;
  text-align: left;
  color: #ffffff;
}
.about-section {
  font-family: "WorkSans";
  font-size: 16px;
  line-height: 1.19;
  text-align: left;
  color: #ffffff;
  cursor: pointer;
  margin-bottom: 35px;
}
.email-input {
  opacity: 0.3;
  font-family: "GTAmerica";
  font-size: 12px;
  font-weight: 500;
  line-height: 1.33;
  text-align: left;
  color: #ffffff;
}
.message-input {
  opacity: 0.3;
  font-family: "GTAmerica";
  font-size: 12px;
  font-weight: 500;
  line-height: 1.33;
  text-align: left;
  color: #ffffff;
}
.terms {
  font-family: "WorkSans";
  font-size: 16px;
  line-height: 1.19;
  text-align: right;
  color: #ffffff;
  margin-top: 50px;
  margin-right: 50px;
}
.privacy {
  font-family: "WorkSans";
  font-size: 16px;
  line-height: 1.19;
  text-align: right;
  color: #ffffff;
  margin-top: 50px;
}
.have-question {
  font-family: "GTAmerica";
  font-size: 16px;
  line-height: 2.38;
  text-align: left;
  color: #ffffff;
  margin-bottom: 33px;
}
.ad {
  margin-top: 20px;
  margin-bottom: 20px;
  color: #000000;
}
.underlined {
  text-decoration: underline;
  cursor: pointer;
}
</style>